module.exports = __webpack_public_path__ + "img/01_logo_CBfull_principal.f74c43d9.png";